import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, List } from '@pella/sash-framework';
import { Image } from '../../..';
import { useMediaQuery } from 'react-responsive';

const ImageClickPoints = ({ data, className, imageClass }) => {
	const [activeIndex, setActiveIndex] = useState(0);
	const verticalPos = data.popouts[activeIndex].position_vertical.replace('%', '');
	const horizontalPos = data.popouts[activeIndex].position_horizontal.replace('%', '');
	const isSmallDevice = useMediaQuery({ query: '(max-width : 767px)' });

	const onTriggerClick = (index) => setActiveIndex(index);

	return (
		<div className={`image-click-points grid grid-cols-1 gap-4 md:grid-cols-2 md:items-center xl:grid-cols-[60%_40%] ${className || ''}`}>
			<div className='relative inline-block'>
				{data?.image?.[0] && (
					<Image
						className={`${imageClass}`}
						data={data.image[0]}
					/>
				)}
				{verticalPos != null && horizontalPos != null && !isSmallDevice && (
					<>
						<span
							className='absolute block w-0.5 bg-black '
							style={{ height: verticalPos > 50 ? `${verticalPos - 50}%` : `${50 - verticalPos}%`, top: verticalPos >= 50 ? `` : `calc(${verticalPos}% + 7px)`, bottom: verticalPos >= 50 ? `calc(100% - ${verticalPos}% - 8px)` : ``, left: `calc(${horizontalPos}% + 7px)` }}
						/>
						<span
							className='absolute  block h-0.5 bg-black'
							style={{ width: horizontalPos > 50 ? `80%` : `calc(100% + ${horizontalPos}%)`, top: verticalPos >= 50 ? `` : `calc(${verticalPos}% + ${50 - verticalPos}% + 7px)`, bottom: verticalPos >= 50 ? `calc(100% - ${verticalPos}% + ${verticalPos - 50}% - 8px)` : ``, left: `calc(${horizontalPos}% + 7px)` }}
						/>
					</>
				)}
				{verticalPos != null && horizontalPos != null && isSmallDevice && (
					<>
						<span
							className='absolute block w-0.5 bg-black '
							style={{ height: verticalPos > 50 ? `80%` : `calc(100% + ${verticalPos}%)`, top: `calc(${verticalPos}% + 7px)`, left: verticalPos >= 50 ? `` : `calc(${verticalPos}% + ${50 - verticalPos}% + 8px)`, right: verticalPos >= 50 ? `calc(100% - ${verticalPos}% + ${verticalPos - 50}% - 8px)` : `` }}
						/>
						<span
							className='absolute block h-0.5 bg-black'
							style={{ width: horizontalPos > 50 ? `${horizontalPos - 50}%` : `${50 - horizontalPos}%`, top: `calc(${verticalPos}% + 7px)`, left: horizontalPos >= 50 ? '' : `calc(${horizontalPos}% + 7px)`, right: horizontalPos >= 50 ? `calc(100% - ${horizontalPos}% - 8px)` : '' }}
						/>
					</>
				)}
				{data?.popouts?.[0] && (
					<List bullets='none'>
						{data.popouts.map((popout, index) => {
							return (
								<li
									key={index}
									style={{ top: popout.position_vertical, left: popout.position_horizontal }}
									className='absolute'
								>
									{index === activeIndex && <span className='block h-4 w-4 rounded-full bg-black' />}
									{index !== activeIndex && (
										<button
											onClick={() => onTriggerClick(index)}
											className='flex items-center gap-2.5 bg-white px-0.5 py-1 text-left font-semibold text-black'
										>
											<Icon
												name='add'
												className='block text-black'
											/>

											{popout.heading && <p className='text-body-2 max-w-[24ch] font-semibold uppercase tracking-[1.25px] text-black'>{popout.heading}</p>}
										</button>
									)}
								</li>
							);
						})}
					</List>
				)}
			</div>
			<div>
				{data?.popouts?.[0] &&
					data.popouts.map((popout, index) => {
						if (index !== activeIndex) return null;

						return (
							<div
								key={index}
								className='relative z-2 border border-black bg-white p-4'
							>
								{popout?.file?.url && (
									<Image
										className='!block aspect-[1.33]'
										data={{ image: popout.file }}
									/>
								)}
								{popout.heading && <p className='text-body-2 py-1.5 font-semibold uppercase tracking-[1.25px] text-black md:py-2 xl:py-2.5'>{popout.heading}</p>}
								{popout.description && (
									<div
										className='text-body-2 text-black'
										dangerouslySetInnerHTML={{ __html: popout.description }}
									/>
								)}
							</div>
						);
					})}
			</div>
		</div>
	);
};

ImageClickPoints.propTypes = {
	data: PropTypes.object.isRequired,
	className: PropTypes.string,
	imageClass: PropTypes.string,
};

export default ImageClickPoints;
